import React, {Component} from 'react';
import './Filter.css';

export default class Filter extends Component {

  constructor(props) {
    super(props)
    this.state = {
      price: "middle",
      type: "",
    }
  }

  render() {
    const {price, type, setPrice} = this.props
    return (
      <div className="filter">
        <div className="priceSelect">
          <h2>How generous are you feeling?</h2>
          <nav className="radios">
            <a className={ price === "cheap" ? "cheap selected" : "cheap" } onClick={() => setPrice("cheap")}>
              £
            </a>
            <a className={ price === "middle" ? "middle selected" : "middle" } onClick={() => setPrice("middle")}>
              ££
            </a>
            <a className={ price === "expensive" ? "expensive selected" : "expensive" } onClick={() => setPrice("expensive")}>
              £££
            </a>
          </nav>
        </div>
        <div className="typeOfGift">
          <h2>Any idea on the type of gift?</h2>
          <nav className="giftTypes">
            <div className="giftType" onClick={ (e) => this.props.handleTypeChange(e, "Gift Sets") }>
              <input type="checkbox" id="giftSets" checked={ type === "Gift Sets" } />
              <label for="giftSets">Gift Sets</label>
              <img src={`${process.env.PUBLIC_URL}/gift_sets.jpg`} />
            </div>
            <div className="giftType" onClick={ (e) => this.props.handleTypeChange(e, "Fragrances") }>
              <input type="checkbox" id="fragrances" checked={ type === "Fragrances" } />
              <label for="fragrances">Fragrances</label>
              <img src={`${process.env.PUBLIC_URL}/fragrance.png`} />
            </div>
            <div className="giftType" onClick={ (e) => this.props.handleTypeChange(e, "Home Fragrance") }>
              <input type="checkbox" id="homeFragrance" checked={ type === "Home Fragrance" } />
              <label for="homeFragrance">Home Fragrances</label>
              <img src={`${process.env.PUBLIC_URL}/home_fragrance.jpg`} />
            </div>
            <div className="giftType" onClick={ (e) => this.props.handleTypeChange(e, "Bath and Body") }>
              <input type="checkbox" id="bathBody" checked={ type === "Bath and Body" } />
              <label for="bathBody">Bath &amp; Body</label>
              <img src={`${process.env.PUBLIC_URL}bath_and_body.jpg`} />
            </div>
            <div className="giftType" onClick={ (e) => this.props.handleTypeChange(e, "Surprise Me") }>
              <input type="checkbox" id="surprise" checked={ type === "Surprise Me" } />
              <label for="surprise">Surprise Me</label>
              <img src={`${process.env.PUBLIC_URL}/surprise_me.jpg`} />
            </div>
          </nav>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Filter/Filter.js